import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import OfferClasses from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { Services } from "Services";
import { SuccessSwal, warningSwal } from "Util/Toast";
import ReactLoading from "react-loading";
import MainLoader from "Components/loader/loader";
window.Buffer = window.Buffer || require("buffer").Buffer;

function SectionFields({ control, register, sectionIndex, removeSection }) {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `Sections.${sectionIndex}.clauses`,
    });

    return (
        <div className={OfferClasses["repeaterCard"]}>
            <div className={OfferClasses["repeaterHeader"]}>
                <strong>Section {sectionIndex + 1}</strong>
                <button
                    type="button"
                    className={OfferClasses["removeBtn"]}
                    onClick={removeSection}>
                    Remove Section
                </button>
            </div>
            <div className={OfferClasses["form-control"]}>
                <label>Section Number</label>
                <input
                    type="number"
                    {...register(`Sections.${sectionIndex}.sectionNumber`)}
                />
            </div>
            <div className={OfferClasses["form-control-full"]}>
                <label>Section Title</label>
                <input
                    type="text"
                    placeholder="e.g. 1. What we promise"
                    {...register(`Sections.${sectionIndex}.title`, {
                        required: true,
                    })}
                />
            </div>
            <div className={OfferClasses["clausesWrapper"]}>
                {fields.map((field, clauseIndex) => (
                    <div
                        key={field.id}
                        className={OfferClasses["repeaterCard"]}>
                        <div className={OfferClasses["repeaterHeader"]}>
                            <strong>Clause {clauseIndex + 1}</strong>
                            <button
                                type="button"
                                className={OfferClasses["removeBtn"]}
                                onClick={() => remove(clauseIndex)}>
                                Remove Clause
                            </button>
                        </div>
                        <div className={OfferClasses["form-control"]}>
                            <label>Clause No.</label>
                            <input
                                type="text"
                                placeholder="e.g. 2.1"
                                {...register(
                                    `Sections.${sectionIndex}.clauses.${clauseIndex}.clauseNum`
                                )}
                            />
                        </div>
                        <div className={OfferClasses["form-control-full"]}>
                            <label>Clause Text</label>
                            <Controller
                                name={`Sections.${sectionIndex}.clauses.${clauseIndex}.text`}
                                control={control}
                                rules={{
                                    validate: (value) =>
                                        (value && value.trim().length > 0) ||
                                        "This field is required",
                                }}
                                render={({ field }) => (
                                    <Editor
                                        tinymceScriptSrc={
                                            process.env.PUBLIC_URL +
                                            "/tinymce/tinymce.min.js"
                                        }
                                        value={field.value}
                                        onEditorChange={field.onChange}
                                        init={{
                                            license_key: "gpl",
                                            height: 220,
                                            menubar: false,
                                            branding: false,
                                            plugins: "link lists code",
                                            toolbar:
                                                "undo redo | bold italic underline | bullist numlist | link | code",
                                            valid_elements: "*[*]",
                                            extended_valid_elements: "*[*]",
                                        }}
                                    />
                                )}
                            />
                        </div>
                    </div>
                ))}
                <button
                    type="button"
                    className={OfferClasses["addBtn"]}
                    onClick={() => append({ clauseNum: "", text: "" })}>
                    + Add Clause
                </button>
            </div>
        </div>
    );
}

function AddOffer() {
    const { slug } = useParams();
    const edit = Boolean(slug);
    const [loading, setLoading] = useState(false);
    const [mainLoad, setMainLoad] = useState(edit);
    const [offerPageId, setOfferPageId] = useState(null);
    const Navigate = useNavigate();
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            Slug: "",
            Title: "",
            Version: "",
            EffectiveFrom: "",
            EffectiveTo: "",
            Badge: "",
            CompanyMeta: "",
            ScopeBannerText: "",
            Highlights: [],
            Sections: [],
        },
    });
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    // Highlights (folded into Sections instead — commented out for now)
    // const {
    //     fields: highlightFields,
    //     append: appendHighlight,
    //     remove: removeHighlight,
    // } = useFieldArray({ control, name: "Highlights" });

    const {
        fields: sectionFields,
        append: appendSection,
        remove: removeSection,
    } = useFieldArray({ control, name: "Sections" });

    useEffect(() => {
        if (edit) {
            Services.getOfferBySlug("GET", null, token, slug)
                .then((response) => {
                    setTimeout(() => {
                        setMainLoad(false);
                    }, 200);
                    if (response.Status === 1 && response.Offer) {
                        const offer = response.Offer;
                        setOfferPageId(offer.OfferPageID);
                        reset({
                            Slug: offer.Slug,
                            Title: offer.Title,
                            Version: offer.Version,
                            EffectiveFrom: offer.EffectiveFrom
                                ? String(offer.EffectiveFrom).slice(0, 10)
                                : "",
                            EffectiveTo: offer.EffectiveTo
                                ? String(offer.EffectiveTo).slice(0, 10)
                                : "",
                            Badge: offer.Badge || "",
                            CompanyMeta: offer.CompanyMeta || "",
                            ScopeBannerText: offer.ScopeBannerText || "",
                            Highlights: offer.Highlights || [],
                            Sections: offer.Sections || [],
                        });
                    } else if (response.Status === 0) {
                        warningSwal("Warning", response.Message);
                    }
                })
                .catch((err) => {
                    setMainLoad(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
        // eslint-disable-next-line
    }, [slug]);

    const onSubmit = (data) => {
        const payload = {
            Slug: data.Slug,
            Title: data.Title,
            Version: data.Version,
            EffectiveFrom: data.EffectiveFrom,
            EffectiveTo: data.EffectiveTo || null,
            Badge: data.Badge || undefined,
            CompanyMeta: data.CompanyMeta || undefined,
            ScopeBannerText: data.ScopeBannerText || undefined,
            Highlights: data.Highlights || [],
            Sections: (data.Sections || []).map((section) => ({
                ...section,
                sectionNumber:
                    section.sectionNumber !== "" &&
                    section.sectionNumber !== null &&
                    section.sectionNumber !== undefined
                        ? Number(section.sectionNumber)
                        : null,
            })),
            Status: "published",
        };

        setLoading(true);
        const request = edit
            ? Services.updateOffer(
                  "PUT",
                  JSON.stringify(payload),
                  token,
                  offerPageId
              )
            : Services.addOffer("POST", JSON.stringify(payload), token);

        request
            .then((response) => {
                if (response.Status === 1) {
                    Navigate(-1);
                    SuccessSwal("Success", response.Message);
                } else {
                    setLoading(false);
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const backButton = () => {
        Navigate(-1);
    };

    return (
        <Layout Active={"Offers"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`${edit ? "Update" : "Add"} Offer`}</title>
            </Helmet>
            {mainLoad && <MainLoader />}
            <div className={OfferClasses["Container"]}>
                <button onClick={backButton} className={OfferClasses["back"]}>
                    Back
                </button>
                <div className={OfferClasses["wrapper"]}>
                    <h3>{!edit ? "Add Offer" : "Update Offer"}</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div
                            className={OfferClasses["form-control"]}
                            style={{ display: "none" }}>
                            <label htmlFor="Slug">Slug</label>
                            <input
                                type="text"
                                placeholder="summer-2026"
                                disabled={edit}
                                {...register("Slug")}
                            />
                            {errors.Slug && (
                                <span>This field is required</span>
                            )}
                        </div>
                        <div className={OfferClasses["form-control"]}>
                            <label htmlFor="Title">Title</label>
                            <input
                                type="text"
                                {...register("Title", { required: true })}
                            />
                            {errors.Title && (
                                <span>This field is required</span>
                            )}
                        </div>
                        <div
                            className={OfferClasses["form-control"]}
                            style={{ display: "none" }}>
                            <label htmlFor="Version">Version</label>
                            <input
                                type="text"
                                placeholder="v1.0"
                                {...register("Version")}
                            />
                            {errors.Version && (
                                <span>This field is required</span>
                            )}
                        </div>
                        <div className={OfferClasses["form-control"]}>
                            <label htmlFor="Badge">Badge</label>
                            <input
                                type="text"
                                placeholder="50% Off"
                                {...register("Badge")}
                            />
                        </div>
                        <div className={OfferClasses["form-control"]}>
                            <label htmlFor="EffectiveFrom">
                                Effective From
                            </label>
                            <input
                                type="date"
                                {...register("EffectiveFrom", {
                                    required: true,
                                })}
                            />
                            {errors.EffectiveFrom && (
                                <span>This field is required</span>
                            )}
                        </div>
                        <div className={OfferClasses["form-control"]}>
                            <label htmlFor="EffectiveTo">
                                Effective To (optional)
                            </label>
                            <input type="date" {...register("EffectiveTo")} />
                        </div>
                        <div className={OfferClasses["form-control-full"]}>
                            <label htmlFor="CompanyMeta">Company Meta</label>
                            <textarea {...register("CompanyMeta")} />
                        </div>
                        <div className={OfferClasses["form-control-full"]}>
                            <label htmlFor="ScopeBannerText">
                                Scope Banner Text
                            </label>
                            <textarea {...register("ScopeBannerText")} />
                        </div>

                        {/* Highlights (folded into Sections instead — commented out for now)
                        <h3>Highlights</h3>
                        {highlightFields.map((field, index) => (
                            <div
                                key={field.id}
                                className={OfferClasses["repeaterCard"]}>
                                <div
                                    className={OfferClasses["repeaterHeader"]}>
                                    <strong>Highlight {index + 1}</strong>
                                    <button
                                        type="button"
                                        className={OfferClasses["removeBtn"]}
                                        onClick={() => removeHighlight(index)}>
                                        Remove
                                    </button>
                                </div>
                                <div className={OfferClasses["form-control"]}>
                                    <label>Icon</label>
                                    <input
                                        type="text"
                                        placeholder="🛡️"
                                        {...register(
                                            `Highlights.${index}.icon`
                                        )}
                                    />
                                </div>
                                <div className={OfferClasses["form-control"]}>
                                    <label>Title</label>
                                    <input
                                        type="text"
                                        {...register(
                                            `Highlights.${index}.title`
                                        )}
                                    />
                                </div>
                                <div
                                    className={
                                        OfferClasses["form-control-full"]
                                    }>
                                    <label>Description</label>
                                    <textarea
                                        {...register(
                                            `Highlights.${index}.description`
                                        )}
                                    />
                                </div>
                            </div>
                        ))}
                        <button
                            type="button"
                            className={OfferClasses["addBtn"]}
                            onClick={() =>
                                appendHighlight({
                                    icon: "",
                                    title: "",
                                    description: "",
                                })
                            }>
                            + Add Highlight
                        </button>
                        */}

                        <h3>Sections</h3>
                        {sectionFields.map((field, index) => (
                            <SectionFields
                                key={field.id}
                                control={control}
                                register={register}
                                sectionIndex={index}
                                removeSection={() => removeSection(index)}
                            />
                        ))}
                        <button
                            type="button"
                            className={OfferClasses["addBtn"]}
                            onClick={() =>
                                appendSection({
                                    sectionNumber: sectionFields.length + 1,
                                    title: "",
                                    clauses: [],
                                })
                            }>
                            + Add Section
                        </button>

                        <button disabled={loading}>
                            {loading ? (
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
}

export default AddOffer;
